import { useState } from 'react';

import { Input } from '@/components/ui/input';
import { isKeyEnter } from '@/util/events';

interface TextFilterProps {
  value: string | undefined;
  placeholder?: string;
  onApply: (value: string | undefined) => void;
}

export const TextFilter = ({ value, placeholder, onApply }: TextFilterProps) => {
  const [inputValue, setInputValue] = useState(value ?? '');

  const handleApply = () => {
    const trimmed = inputValue.trim();
    onApply(trimmed || undefined);
  };

  return (
    <div className="px-3 pt-2 pb-4">
      <Input
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={placeholder}
        onKeyDown={(e) => {
          if (isKeyEnter(e)) {
            handleApply();
          }
        }}
        onBlur={handleApply}
        autoFocus
      />
    </div>
  );
};
